import { Box, Table, Text, VStack } from "@chakra-ui/react";
import { formatNumber, formatPercent } from "../../../../store/helpers";
import LineGraph from "../../../daily/LineGraph";
import ReportDataTable from "../../../reports/ReportDataTable";
import { TICKET_SUMMARY_COLUMN_DEFINITIONS } from "../../../../store/renderConfig";
import { renderTicketSummaryCell } from "../AllTicketsTable";

const TicketsPerBranchTable = ({ branchData, index, reportIndex, renderConfig, onRenderConfigChange }) => {
  const {
    branchName,
    min,
    max,
    total,
    average,
    totalPct,
    numServices,
    chart,
    totalCompleted,
    completedPct,
    totalNoShow,
    noShowPct,
    totalUnattended,
    unattendedPct,
  } = branchData;

  const titlePrefix = reportIndex ? `${reportIndex}.${index + 1}` : `${index + 1}`;
  const title = `${titlePrefix}. ${branchName} Branch`;

  if (!renderConfig?.charts?.enabled) {
    return (
      <Box className="ticketSummaryBlock">
        <h2>{title}</h2>
        <Text>{numServices} services</Text>
        <ReportDataTable
          columns={TICKET_SUMMARY_COLUMN_DEFINITIONS}
          rows={[{
            ...branchData,
            scopeName: `${branchName} Branch`,
            completed: totalCompleted,
            noShow: totalNoShow,
            unattended: totalUnattended,
          }]}
          renderConfig={renderConfig}
          renderCell={renderTicketSummaryCell}
          onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
        />
      </Box>
    );
  }
  
  return (
    <Box>
      <h2>{title}</h2>
      <Text>{numServices} services</Text>

      {total ? (
        <Table.Root className="stripedTable" size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
              <Table.ColumnHeader>Min</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Max</Table.ColumnHeader>
              <Table.ColumnHeader>Completed</Table.ColumnHeader>
              <Table.ColumnHeader>No Show</Table.ColumnHeader>
              <Table.ColumnHeader>Unattended</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{index + 1}</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">
                <VStack gap="2px" alignItems="flex-start">
                  <Text color={"var(--green)"}>
                    {formatNumber(total)}
                  </Text>
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    fontSize="xs"
                    textTransform="uppercase"
                  >
                    ({formatPercent(totalPct)})
                  </Box>
                </VStack>
              </Table.Cell>

              <Table.Cell borderRight="1px solid #dadce0">{formatNumber(average)}</Table.Cell>
              <Table.Cell>{formatNumber(min)}</Table.Cell>
              <Table.Cell>{formatNumber(max)}</Table.Cell>
              <Table.Cell>
                <VStack gap="2px" alignItems="flex-start">
                  <Text color={"var(--green)"}>
                    {!Number.isNaN(totalCompleted) ? formatNumber(totalCompleted) : "NA"}
                  </Text>
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    fontSize="xs"
                    textTransform="uppercase"
                  >
                    {!Number.isNaN(completedPct)
                      ? `(${formatPercent(completedPct)})`
                      : "NA"}
                  </Box>
                </VStack>
              </Table.Cell>

              <Table.Cell>
                <VStack gap="2px" alignItems="flex-start">
                  <Text cursor="pointer" color={"var(--red)"}>
                    {!Number.isNaN(totalNoShow) ? formatNumber(totalNoShow) : "NA"}
                  </Text>
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    fontSize="xs"
                    textTransform="uppercase"
                  >
                    {!Number.isNaN(noShowPct) ? `(${formatPercent(noShowPct)})` : "NA"}
                  </Box>
                </VStack>
              </Table.Cell>

              <Table.Cell>
                <VStack gap="2px" alignItems="flex-start">
                  <Text color={"var(--red)"}>
                    {!Number.isNaN(totalUnattended)
                      ? formatNumber(totalUnattended)
                      : "NA"}
                  </Text>
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    fontSize="xs"
                    textTransform="uppercase"
                  >
                    {!Number.isNaN(unattendedPct)
                      ? `(${formatPercent(unattendedPct)})`
                      : "NA"}
                  </Box>
                </VStack>
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell colSpan={8}>
                <Box mt="20px" mb="20px">
                  <LineGraph
                    chart={chart}
                    title={`${branchName} tickets, Hour by Hour Comparison`}
                    height={"300px"}
                  />
                </Box>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table.Root>
      ) : (
        <>
          {" "}
          <Text fontSize="sm">No data available for this report</Text>
        </>
      )}
    </Box>
  );
};

export default TicketsPerBranchTable;
